import { IAppState } from '../../../../../AppModulesWrapper';

import { EPaymentStatus } from '../../../../services/billingPayments';
import { selectPackagePayment } from './selectPackagePayment';

export const selectIsRecommendedPackagePaymentStatusCheckInProgress = (state: IAppState): boolean => {
  const payment = selectPackagePayment(state);

  if (!payment) {
    return false;
  }

  return Boolean(payment.status) && payment.status !== EPaymentStatus.Succeeded;
};
